import React, { useEffect, useState } from "react";
import axios from "axios";
import { BASE_API_URL, DEFAULT_AXIOS_OPTIONS } from "../../AppConstants";
import { FilteringMenu } from "../../components/Filter/FilteringMenu";
import zine from "../../images/upright-zine.png";

export const Welcome = () => {
  const [searchTerm, setSearchTerm] = useState("");

  const [creatorOptions, setCreatorOptions] = useState([]);
  const [backgroundOptions, setBackgroundOptions] = useState([]);
  const [mediaTypeOptions, setMediaTypeOptions] = useState([]);
  const [genreOptions, setGenreOptions] = useState([]);
  const [themeOptions, setThemeOptions] = useState([]);

  const [creatorsSelected, setCreatorsSelected] = useState([]);
  const [backgroundsSelected, setBackgroundsSelected] = useState([]);
  const [mediaTypesSelected, setMediaTypesSelected] = useState([]);
  const [genresSelected, setGenresSelected] = useState([]);
  const [themesSelected, setThemesSelected] = useState([]);

  const [mediaResults, setMediaResults] = useState([]);
  const [searched, setSearched] = useState(false); // searched keeps track if someone has searched before. setSearched sets the value of searched
  const [expandedResultIds, setExpandedResultIds] = useState(new Set());

  // get mediaTypes
  useEffect(() => {
    axios
      .get(`${BASE_API_URL}/mediatype`, DEFAULT_AXIOS_OPTIONS)
      .then((res) => {
        const selectOptions = res.data.map((mediaType) => ({
          value: mediaType.id,
          label: mediaType.name,
        }));
        setMediaTypeOptions(selectOptions);
      })
      .catch((error) => {
        console.error("error", error);
      });
  }, []);

  // get genres
  useEffect(() => {
    axios
      .get(`${BASE_API_URL}/genre`, DEFAULT_AXIOS_OPTIONS)
      .then((res) => {
        const selectOptions = res.data.map((genre) => ({
          value: genre.id,
          label: genre.name,
        }));
        setGenreOptions(selectOptions);
      })
      .catch((error) => {
        console.error("error", error);
      });
  }, []);

  // get themes
  useEffect(() => {
    axios
      .get(`${BASE_API_URL}/theme`, DEFAULT_AXIOS_OPTIONS)
      .then((res) => {
        const selectOptions = res.data.map((theme) => ({
          value: theme.id,
          label: theme.name,
        }));
        setThemeOptions(selectOptions);
      })
      .catch((error) => {
        console.error("error", error);
      });
  }, []);

  // get backgrounds
  useEffect(() => {
    axios
      .get(`${BASE_API_URL}/background`, DEFAULT_AXIOS_OPTIONS)
      .then((res) => {
        const selectOptions = res.data.map((background) => ({
          value: background.id,
          label: background.name,
        }));
        setBackgroundOptions(selectOptions);
      })
      .catch((error) => {
        console.error("error", error);
      });
  }, []);

  // get creators
  useEffect(() => {
    axios
      .get(`${BASE_API_URL}/creator`, DEFAULT_AXIOS_OPTIONS)
      .then((res) => {
        const selectOptions = res.data.map((creator) => ({
          value: creator.id,
          label: `${creator.firstName} ${creator.lastName}`,
        }));
        setCreatorOptions(selectOptions);
      })
      .catch((error) => {
        console.error("error", error);
      });
  }, []);

  const onSearchClick = () => {
    axios
      .get(`${BASE_API_URL}/media`, {
        params: {
          searchTerm: searchTerm !== "" ? searchTerm : undefined, // user-entered search term. if empty, set to undefined
          // arrays of IDs corresponding to selected media types, backgrounds, genres, themes
          mediaTypeIds: mediaTypesSelected.map((mediaType) => mediaType.value),
          creatorIds: creatorsSelected.map((creator) => creator.value),
          backgroundIds: backgroundsSelected.map(
            (background) => background.value
          ),
          genreIds: genresSelected.map((genre) => genre.value),
          themeIds: themesSelected.map((theme) => theme.value),
        },
        ...DEFAULT_AXIOS_OPTIONS, // spreads default axios options into request
      })
      // sort response data by title
      .then((res) => {
        const sortedResults = res.data.sort((a, b) => {
          return a.title.localeCompare(b.title); //localeCompare compares two strings and returns a value that determines their order (-1, 0, 1). sort() uses return value to determine element order
        });
        setMediaResults(sortedResults); // updates mediaResults state with sortedResults
        setSearched(true); // sets searched state to true, indicating search happened. when true,  featured section disappears
      })
      .catch((error) => {
        console.error("error", error);
      });
  };

  // when Read More/Read Less button is clicked, set expandedResultId to resultId and show or hide more info
  const handleReadMoreClick = (resultId) => {
    const newSet = new Set(expandedResultIds).add(resultId);
    setExpandedResultIds(newSet);
  };

  return (
    <div>
      <div className="columns">
        <div className="column is-one-quarter">
          <FilteringMenu
            creatorOptions={creatorOptions}
            backgroundOptions={backgroundOptions}
            mediaTypeOptions={mediaTypeOptions}
            genreOptions={genreOptions}
            themeOptions={themeOptions}
            creatorsSelected={creatorsSelected}
            setCreatorsSelected={setCreatorsSelected}
            backgroundsSelected={backgroundsSelected}
            setBackgroundsSelected={setBackgroundsSelected}
            mediaTypesSelected={mediaTypesSelected}
            setMediaTypesSelected={setMediaTypesSelected}
            genresSelected={genresSelected}
            setGenresSelected={setGenresSelected}
            themesSelected={themesSelected}
            setThemesSelected={setThemesSelected}
            searchTerm={searchTerm}
            setSearchTerm={setSearchTerm}
            onSearchClick={onSearchClick}
          />
        </div>
        <div className="column">
          <div className="box">
            <div className="content">
              {/* if users haven't searched, show the welcome message */}
              {!searched ? (
                <div className="welcome-box">
                  <div className="welcome-text">
                    <h3>
                      Welcome to the 1882 Foundation’s Literature & Arts Corner
                      Library, where we celebrate the voices of Asian, Pacific
                      Islander, and Desi American communities.
                    </h3>
                    <p>
                      (1) Explore the full collection by clicking "View Media."
                      (2) Use the search box and dropdown menus to filter
                      results. (3) Engage further by adding your media
                      suggestions to the database, reading community-written
                      reviews, and browsing relevant resources via the red
                      navigation bar.
                    </p>
                    <p>
                      Please note that some descriptions are gathered from
                      official sources. Thanks for visiting!
                    </p>
                  </div>
                </div>
              ) : (
                // if users have searched, show the search results
                <div className="box">
                  <p>
                    {searched && <p>{mediaResults.length} results found</p>}
                  </p>
                  {mediaResults.map((media) => {
                    const {
                      id,
                      title,
                      description,
                      releaseDate,
                      lengthDuration,
                      language,
                      mediaTypes = [],
                      genres = [],
                      themes = [],
                      backgrounds = [],
                      creatorRoles = [],
                    } = media;
                    return (
                      // id is a unique key to track each rendered search result
                      <div key={id}>
                        {/* Render Media Type, Genre, and Created By */}
                        <div className="content_element">
                          <h3>{title}</h3>
                          {mediaTypes.length > 0 && (
                            <p className="has-text-grey mr-2">
                              Media Type:{" "}
                              {mediaTypes
                                .map((mediaType) => mediaType.name)
                                .join(", ")}
                            </p>
                          )}
                          {genres.length > 0 && (
                            <p className="has-text-grey mr-2">
                              Genres:{" "}
                              {genres.map((genre) => genre.name).join(", ")}
                            </p>
                          )}
                          {creatorRoles.length > 0 && (
                            // parent element below needed to wrap p and ul elements
                            <>
                              <p className="has-text-grey">Created By:</p>
                              <ul>
                                {creatorRoles.map((creatorRole, index) => (
                                  <li
                                    key={index}
                                  >{`${creatorRole.roleName} - ${creatorRole.firstName} ${creatorRole.lastName}`}</li>
                                ))}
                              </ul>
                            </>
                          )}

                          {/* Render expanded content of selected search result */}
                          {expandedResultIds.has(media.id) && (
                            <div>
                              {description && (
                                <p className="has-text-grey mr-2">
                                  Description: {description}
                                </p>
                              )}
                              {themes.length > 0 && (
                                <p className="has-text-grey mr-2">
                                  Themes:{" "}
                                  {themes.map((theme) => theme.name).join(", ")}
                                </p>
                              )}
                              {backgrounds.length > 0 && (
                                <p className="has-text-grey mr-2">
                                  APIDA Identities:{" "}
                                  {backgrounds
                                    .map((background) => background.name)
                                    .join(", ")}
                                </p>
                              )}
                              {releaseDate && (
                                <p className="has-text-grey mr-2">
                                  Released:{" "}
                                  {new Date(releaseDate).getFullYear()}
                                </p>
                              )}
                              {lengthDuration && (
                                <p className="has-text-grey mr-2">
                                  Length: {lengthDuration}
                                </p>
                              )}
                              {language && (
                                <p className="has-text-grey mr-2">
                                  Original Language: {language}
                                </p>
                              )}
                            </div>
                          )}
                          {/* Read More/Read Less button below all media content*/}
                          {!expandedResultIds.has(media.id) && (
                            <button
                              className="btn btn-danger mx-auto show-more-button"
                              // when button is clicked
                              onClick={() => handleReadMoreClick(media.id)}
                            >
                              Read More
                            </button>
                          )}
                        </div>
                      </div>
                    );
                  })}
                </div>
              )}
            </div>
          </div>
          {/* recommendations box */}
          <div className="box">
            <div className="content">
              {/* if users haven't searched, show the featured message */}
              {!searched && (
                // INTERN ZINE
                <div className="featured-section">
                  <h4 className="featured-header">
                    <u>
                      Our intern created a film discussion guide on{" "}
                      <em>The Farewell</em>. Check out her zine* below!
                    </u>
                  </h4>
                  <div className="featured-all">
                    <div className="featured-single-zine">
                      <div>
                        <a
                          href="https://mega.nz/file/z1QgDbAT#hKBneAmw-PJCdKSIG5lraCpxuGQmFdczpQJHyxlGix0"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <img
                            src={zine}
                            alt="Film discussion guide and zine on The Farewell"
                            className="img-fluid featured-zine"
                          />
                        </a>
                      </div>
                    </div>
                  </div>
                  <p className="zine-description">
                    *A zine is a self-published booklet that shares ideas and
                    perspectives, often made by folding a single sheet of paper.
                    Click the image above to open it in a new tab, with the
                    correct orientation for single-page printing.
                  </p>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
